<template>
  <div>
    <div class="row">
      <div class="col-xxl-12">
        <div class="card">
          <div class="card-body">
            <div class="form row">
              <div class="form-group col-md-3">
                <label class="col-md-12"> Fecha Inicio:*</label>
                <input required type="date" class="form-control" v-model="filtro.data_inicio" />
              </div>
              <div class="form-group col-md-3">
                <label class="col-md-12"> Fecha Final:*</label>
                <input required type="date" class="form-control" v-model="filtro.data_fim" />
              </div>
              <div class="col-md-4">
                <label class="col-md-12"> Seleccione las filiales:*</label>
                <treeselect :multiple="false" :options="lista_filials" v-model="filtro.filiais_id"
                  placeholder="Seleccione una filial..." />

              </div>
              <div class="col-md-1 d-flex pt-6" style="">
                <div class="col-2 pt-2">
                  <b-button variant="success" @click="pesquisar()">
                    <i class="fa fa-search search-icon m-0 p-0"></i>
                  </b-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div v-if="isLoading" class="col-xxl-3 mt-3">
        <div class="card card-border overlay overlay-block card-custom wave  wave-warning card-xl-stretch mb-xl-8">

          <div class="card-body">
            <div class="overlay-wrapper p-5">
              contabilizando datos....
            </div>
            <div class="overlay-layer card-rounded bg-opacity-5">
              <div class="spinner-border text-primary" role="status">
                <span class="visually-hidden"></span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div v-else="isLoading" class="col-xxl-3 mt-3">
        <div class="card card-custom wave  wave-warning ">
          <div class="card-title border-5 pt-5 text-center">
            <h1 > {{ this.total_atendimentos }} </h1>
            <h4>Atendimientos en el total</h4>
          </div>
          <div class="mt-2"></div>
        </div>
       
      </div>

      <div v-if="isLoading" class="col-xxl-3 mt-3">
        <div class="card card-border  wave wave-info overlay overlay-block">

          <div class="card-body">
            <div class="overlay-wrapper p-5">
              contabilizando datos....
            </div>
            <div class="overlay-layer card-rounded bg-opacity-5">
              <div class="spinner-border text-primary" role="status">
                <span class="visually-hidden"></span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div v-else="isLoading" class="col-xxl-3 mt-3">
        <div class="card card-custom wave wave-info border-5 card-xl-stretch mb-xl-8">

          <div class="card-body  pt-5 text-center">
            <h2> {{ this.num_ocorrencias_filial[1] }} <span> triajes</span></h2>

            <div class="d-flex align-items-center w-90 mw-125px">
              <!--begin::Progress-->
              <div class="progress h-6px w-100 me-2 bg-light-infp">
                <div class="progress-bar bg-info" role="progressbar" :style="{ width: porcentagens[1] + '%' }"
                  aria-valuenow="98" aria-valuemin="0" aria-valuemax="100"></div>
              </div>
              <!--end::Progress-->

              <!--begin::Value-->
              <span class="text-gray-500 fw-semibold">
                  {{ porcentagens[1] }}%
              </span>
              <!--end::Value-->
            </div>
            <span class="text-gray-500 " style="font-size: 10px;" >
                {{ porcentagens[4] }}% de los pacientes tienen triajes
              </span>
          </div>

        </div>
      </div>

      <div v-if="isLoading" class="col-xxl-3 mt-3">
        <div class="card card-border  wave wave-primary  overlay overlay-block">

          <div class="card-body">
            <div class="overlay-wrapper p-5">
              contabilizando datos....
            </div>
            <div class="overlay-layer card-rounded bg-opacity-5">
              <div class="spinner-border text-primary" role="status">
                <span class="visually-hidden"></span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div v-else="isLoading" class="col-xxl-3 mt-3">
        <div class="card wave wave-primary  card-xl-stretch mb-xl-8">

          <div class="card-body  pt-5 text-center">
            <h2> {{ this.num_ocorrencias_filial[2] }} <span> consultas</span></h2>

            <div class="d-flex align-items-center w-90 mw-125px">
              <!--begin::Progress-->
              <div class="progress h-6px w-100 me-2 bg-light-primary">
                <div class="progress-bar bg-primary" role="progressbar" :style="{ width: porcentagens[2] + '%' }"
                  aria-valuemin="0" aria-valuemax="100"></div>
              </div>
              <!--end::Progress-->

              <!--begin::Value-->
              <span class="text-gray-500 fw-semibold">
                {{ porcentagens[2] }}%
              </span>
              <!--end::Value-->
            </div>
            <span class="text-gray-500 fw-semibold" style="font-size: 10px;" >
                {{ porcentagens[4] }}% de los pacientes tienen consultas
              </span>
          </div>


        </div>
      </div>

      <div v-if="isLoading" class="col-xxl-3 mt-3">
        <div class="card card-border wave wave-success  overlay overlay-block">

          <div class="card-body">
            <div class="overlay-wrapper p-5">
              contabilizando datos....
            </div>
            <div class="overlay-layer card-rounded bg-opacity-5">
              <div class="spinner-border text-success" role="status">
                <span class="visually-hidden"></span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div v-else="isLoading" class="col-xxl-3 mt-3">
        <div class="card card-custom border-5  wave wave-success card-xl-stretch mb-xl-8">

          <div class="card-body  pt-5 text-center">
            <h2> {{ this.num_ocorrencias_filial[4] }} <span> receitas</span></h2>

            <div class="d-flex align-items-center w-90 mw-125px">
              <!--begin::Progress-->
              <div class="progress h-6px w-100 me-2 bg-light-success">
                <div class="progress-bar bg-success" role="progressbar" :style="{ width: porcentagens[4] + '%' }"
                  aria-valuemin="0" aria-valuemax="100"></div>
                
              </div>
              <!--end::Progress-->

              <!--begin::Value-->
              <span class="text-gray-500 fw-semibold">
                {{ porcentagens[4] }}%
              </span>
              <!--end::Value-->
            </div>
            <span class="text-gray-500 fw-semibold" style="font-size: 10px;" >
                {{ porcentagens[4] }}% de los pacientes tienen recetas
              </span>
          </div>

        </div>
      </div>

      <div class="col-xxl-5 mt-3">

        <div class="card card-xl-stretch mb-xl-8">

          <div class="card-header border-0 pt-5">
            <h3 class="card-title align-items-start flex-column">
              <span class="card-label fw-bold fs-3 mb-1">Transferencias</span>
            </h3>
            <span class="text-muted fw-semibold fs-7">{{ dados_transferencias.total }} produtos recebidos en el
              total</span>
          </div>

          <div class="card-body py-3">

            <div class="table-responsive">

              <table class="table align-middle gs-0 gy-5">

                <thead>
                  <tr>
                    <th class="p-0 w-50px"></th>
                    <th class="p-0 min-w-200px"></th>

                    <th class="p-0 min-w-100px"></th>
                  </tr>
                </thead>

                <tbody>
                  <tr v-for="lista, index in dados_transferencias.dados">
                    <th>
                      <div class="symbol symbol-50px me-2">
                        <span class="symbol-label symbol-warning">
                          {{ lista.quantidade_produtos }}
                        </span>
                      </div>
                    </th>

                    <td>
                      <a href="#" class="text-gray-900 fw-bold text-hover-primary mb-1 fs-6">recibido de {{ index }}
                        Central</a>
                      <span class="text-muted fw-semibold d-block fs-7" v-if="dados_transferencias">{{
                        dados_transferencias.data_inicio }} - {{ dados_transferencias.data_fim }}</span>
                    </td>



                    <td class="text-end">
                      <button class="btn btn-light" @click="selectProduto(lista.produtos, index)">
                        <i class="fa fa-eye"></i> ver produtos </button>
                    </td>
                  </tr>

                </tbody>
                <!--end::Table body-->
              </table>
              <!--end::Table-->
            </div>
            <!--end::Table container-->
          </div>
          <!--end::Body-->
        </div>
        <!--endW::Tables Widget 1-->
      </div>

      <div class="col-xxl-7 mt-3">

        <div class="card card-flush h-xl-100">

          <div class="card-header border-0 pt-5">

            <h3 class="card-title align-items-start flex-column">
              <span class="card-label fw-bold text-gray-800">Produtos recibidos de {{ nome_filial }}</span>

            </h3>

            <div class="card-toolbar">

              <div data-kt-daterangepicker="true" data-kt-daterangepicker-opens="left"
                class="btn btn-sm btn-light d-flex align-items-center px-4" data-kt-initialized="1">

                <div class="text-gray-600 fw-bold">{{ dados_transferencias.data_inicio }} - {{ dados_transferencias.data_fim }}</div>

                <i class="ki-duotone ki-calendar-8 text-gray-500 lh-0 fs-2 ms-2 me-0"><span class="path1"></span><span
                    class="path2"></span><span class="path3"></span><span class="path4"></span><span
                    class="path5"></span><span class="path6"></span></i>
              </div>

            </div>

          </div>


          <div class="card-body pt-1 pb-4">

            <div class="table-responsive">

              <table class="table table-row-dashed align-middle gs-0 gy-4 my-0">

                <thead>
                  <tr class="fs-7 fw-bold text-gray-500 border-bottom-0">
                    <th class="p-0 min-w-200px"></th>
                    <th class="p-0 min-w-150px"></th>
                    <th class="p-0 min-w-125px"></th>
                    <th class="p-0 w-100px"></th>
                  </tr>
                </thead>

                <tbody>
                  <tr v-for="item in lista_produtos">
                    <td>
                      <div class="d-flex align-items-center">
                        <div class="d-flex justify-content-start flex-column">
                          <a href="/metronic8/demo1/../demo1/account/overview.html"
                            class="text-gray-800 fw-bold text-hover-primary mb-1 fs-6">{{ item.nome }}</a>
                        </div>
                      </div>
                    </td>

                    <td class="text-end">
                      <span class="text-gray-800 fw-bold d-block mb-1 fs-6">{{ item.total }}</span>
                      <span class="fw-semibold text-gray-500 d-block">Recibido</span>
                    </td>

                    <td class="text-end">
                      <a href="#" class="text-gray-800 fw-bold text-hover-primary d-block mb-1 fs-6"> - </a>
                      <span class="text-gray-500 fw-semibold d-block fs-7">Salidas</span>
                    </td>



                    <td class="text-end">
                      <a href="#" class="btn btn-sm btn-icon btn-bg-light btn-active-color-primary w-25px h-25px">
                        <i class="ki-duotone ki-black-right fs-2 text-gray-500"></i> </a>
                    </td>
                  </tr>

                </tbody>
                <!--end::Table body-->
              </table>
            </div>
            <!--end::Table container-->
          </div>
          <!--end: Card Body-->
        </div>
        <!--end::Table widget 13-->
      </div>

      <div class="col-xxl-6 mt-3">
        <div class="card card-flush h-xl-100">
          <!--begin::Header-->
          <div class="card-header border-0 pt-5">
            <h3 class="card-title align-items-start flex-column">
              <span class="card-label fw-bold text-gray-900">Produtos mas transferidos</span>
            </h3>

            <!--begin::Toolbar-->
            <div class="card-toolbar">
              <a href="#" class="btn btn-sm btn-light">All Lessons</a>
            </div>
            <!--end::Toolbar-->
          </div>
          <!--end::Header-->

          <!--begin::Body-->
          <div class="card-body pt-5">

            <!--begin::Item-->
            <div class="d-flex flex-stack">
              <!--begin::Wrapper-->
              <div class="d-flex align-items-center me-3">
                <!--begin::Logo-->
                <img src="/metronic8/demo1/assets/media/svg/brand-logos/laravel-2.svg" class="me-4 w-30px" alt="">
                <!--end::Logo-->

                <!--begin::Section-->
                <div class="flex-grow-1">
                  <!--begin::Text-->
                  <a href="#" class="text-gray-800 text-hover-primary fs-5 fw-bold lh-0">Laravel</a>
                  <!--end::Text-->

                  <!--begin::Description-->
                  <span class="text-gray-500 fw-semibold d-block fs-6">PHP Framework</span>
                  <!--end::Description--->
                </div>
                <!--end::Section-->
              </div>
              <!--end::Wrapper-->

              <!--begin::Statistics-->
              <div class="d-flex align-items-center w-100 mw-125px">
                <!--begin::Progress-->
                <div class="progress h-6px w-100 me-2 bg-light-success">
                  <div class="progress-bar bg-success" role="progressbar" style="width: 65%" aria-valuenow="65"
                    aria-valuemin="0" aria-valuemax="100"></div>
                </div>
                <!--end::Progress-->

                <!--begin::Value-->
                <span class="text-gray-500 fw-semibold">
                  65%
                </span>
                <!--end::Value-->
              </div>
              <!--end::Statistics-->
            </div>
            <!--end::Item-->

            <!--begin::Separator-->
            <div class="separator separator-dashed my-3"></div>
            <!--end::Separator-->


            <!--begin::Item-->
            <div class="d-flex flex-stack">
              <!--begin::Wrapper-->
              <div class="d-flex align-items-center me-3">
                <!--begin::Logo-->
                <img src="/metronic8/demo1/assets/media/svg/brand-logos/vue-9.svg" class="me-4 w-30px" alt="">
                <!--end::Logo-->

                <!--begin::Section-->
                <div class="flex-grow-1">
                  <!--begin::Text-->
                  <a href="#" class="text-gray-800 text-hover-primary fs-5 fw-bold lh-0">Vue 3</a>
                  <!--end::Text-->

                  <!--begin::Description-->
                  <span class="text-gray-500 fw-semibold d-block fs-6">JS Framework</span>
                  <!--end::Description--->
                </div>
                <!--end::Section-->
              </div>
              <!--end::Wrapper-->

              <!--begin::Statistics-->
              <div class="d-flex align-items-center w-100 mw-125px">
                <!--begin::Progress-->
                <div class="progress h-6px w-100 me-2 bg-light-warning">
                  <div class="progress-bar bg-warning" role="progressbar" style="width: 87%" aria-valuenow="87"
                    aria-valuemin="0" aria-valuemax="100"></div>
                </div>
                <!--end::Progress-->

                <!--begin::Value-->
                <span class="text-gray-500 fw-semibold">
                  87%
                </span>
                <!--end::Value-->
              </div>
              <!--end::Statistics-->
            </div>
            <!--end::Item-->

            <!--begin::Separator-->
            <div class="separator separator-dashed my-3"></div>
            <!--end::Separator-->


            <!--begin::Item-->
            <div class="d-flex flex-stack">
              <!--begin::Wrapper-->
              <div class="d-flex align-items-center me-3">
                <!--begin::Logo-->
                <img src="/metronic8/demo1/assets/media/svg/brand-logos/bootstrap5.svg" class="me-4 w-30px" alt="">
                <!--end::Logo-->

                <!--begin::Section-->
                <div class="flex-grow-1">
                  <!--begin::Text-->
                  <a href="#" class="text-gray-800 text-hover-primary fs-5 fw-bold lh-0">Bootstrap 5</a>
                  <!--end::Text-->

                  <!--begin::Description-->
                  <span class="text-gray-500 fw-semibold d-block fs-6">CSS Framework</span>
                  <!--end::Description--->
                </div>
                <!--end::Section-->
              </div>
              <!--end::Wrapper-->

              <!--begin::Statistics-->
              <div class="d-flex align-items-center w-100 mw-125px">
                <!--begin::Progress-->
                <div class="progress h-6px w-100 me-2 bg-light-primary">
                  <div class="progress-bar bg-primary" role="progressbar" style="width: 44%" aria-valuenow="44"
                    aria-valuemin="0" aria-valuemax="100"></div>
                </div>
                <!--end::Progress-->

                <!--begin::Value-->
                <span class="text-gray-500 fw-semibold">
                  44%
                </span>
                <!--end::Value-->
              </div>
              <!--end::Statistics-->
            </div>
            <!--end::Item-->

            <!--begin::Separator-->
            <div class="separator separator-dashed my-3"></div>
            <!--end::Separator-->


            <!--begin::Item-->
            <div class="d-flex flex-stack">
              <!--begin::Wrapper-->
              <div class="d-flex align-items-center me-3">
                <!--begin::Logo-->
                <img src="/metronic8/demo1/assets/media/svg/brand-logos/angular-icon.svg" class="me-4 w-30px" alt="">
                <!--end::Logo-->

                <!--begin::Section-->
                <div class="flex-grow-1">
                  <!--begin::Text-->
                  <a href="#" class="text-gray-800 text-hover-primary fs-5 fw-bold lh-0">Angular 16</a>
                  <!--end::Text-->

                  <!--begin::Description-->
                  <span class="text-gray-500 fw-semibold d-block fs-6">JS Framework</span>
                  <!--end::Description--->
                </div>
                <!--end::Section-->
              </div>
              <!--end::Wrapper-->

              <!--begin::Statistics-->
              <div class="d-flex align-items-center w-100 mw-125px">
                <!--begin::Progress-->
                <div class="progress h-6px w-100 me-2 bg-light-info">
                  <div class="progress-bar bg-info" role="progressbar" style="width: 70%" aria-valuenow="70"
                    aria-valuemin="0" aria-valuemax="100"></div>
                </div>
                <!--end::Progress-->

                <!--begin::Value-->
                <span class="text-gray-500 fw-semibold">
                  70%
                </span>
                <!--end::Value-->
              </div>
              <!--end::Statistics-->
            </div>
            <!--end::Item-->

            <!--begin::Separator-->
            <div class="separator separator-dashed my-3"></div>
            <!--end::Separator-->


            <!--begin::Item-->
            <div class="d-flex flex-stack">
              <!--begin::Wrapper-->
              <div class="d-flex align-items-center me-3">
                <!--begin::Logo-->
                <img src="/metronic8/demo1/assets/media/svg/brand-logos/spring-3.svg" class="me-4 w-30px" alt="">
                <!--end::Logo-->

                <!--begin::Section-->
                <div class="flex-grow-1">
                  <!--begin::Text-->
                  <a href="#" class="text-gray-800 text-hover-primary fs-5 fw-bold lh-0">Spring</a>
                  <!--end::Text-->

                  <!--begin::Description-->
                  <span class="text-gray-500 fw-semibold d-block fs-6">Java Framework</span>
                  <!--end::Description--->
                </div>
                <!--end::Section-->
              </div>
              <!--end::Wrapper-->

              <!--begin::Statistics-->
              <div class="d-flex align-items-center w-100 mw-125px">
                <!--begin::Progress-->
                <div class="progress h-6px w-100 me-2 bg-light-danger">
                  <div class="progress-bar bg-danger" role="progressbar" style="width: 56%" aria-valuenow="56"
                    aria-valuemin="0" aria-valuemax="100"></div>
                </div>
                <!--end::Progress-->

                <!--begin::Value-->
                <span class="text-gray-500 fw-semibold">
                  56%
                </span>
                <!--end::Value-->
              </div>
              <!--end::Statistics-->
            </div>
            <!--end::Item-->

            <!--begin::Separator-->
            <div class="separator separator-dashed my-3"></div>
            <!--end::Separator-->


            <!--begin::Item-->
            <div class="d-flex flex-stack">
              <!--begin::Wrapper-->
              <div class="d-flex align-items-center me-3">
                <!--begin::Logo-->
                <img src="/metronic8/demo1/assets/media/svg/brand-logos/typescript-1.svg" class="me-4 w-30px" alt="">
                <!--end::Logo-->

                <!--begin::Section-->
                <div class="flex-grow-1">
                  <!--begin::Text-->
                  <a href="#" class="text-gray-800 text-hover-primary fs-5 fw-bold lh-0">TypeScript</a>
                  <!--end::Text-->

                  <!--begin::Description-->
                  <span class="text-gray-500 fw-semibold d-block fs-6">Better Tooling</span>
                  <!--end::Description--->
                </div>
                <!--end::Section-->
              </div>
              <!--end::Wrapper-->

              <!--begin::Statistics-->
              <div class="d-flex align-items-center w-100 mw-125px">
                <!--begin::Progress-->
                <div class="progress h-6px w-100 me-2 bg-light-success">
                  <div class="progress-bar bg-success" role="progressbar" style="width: 82%" aria-valuenow="82"
                    aria-valuemin="0" aria-valuemax="100"></div>
                </div>
                <!--end::Progress-->

                <!--begin::Value-->
                <span class="text-gray-500 fw-semibold">
                  82%
                </span>
                <!--end::Value-->
              </div>
              <!--end::Statistics-->
            </div>
            <!--end::Item-->



          </div>
          <!--end::Body-->
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import { Bar } from "vue-chartjs/legacy";
import { SET_BREADCRUMB } from "@/core/store/breadcrumbs.module";
import saidasclasses from "@/view/components/relatorios/graficos/saidas_por_classe";
import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  BarElement,
  CategoryScale,
  LinearScale,
} from "chart.js";
import M from "minimatch";
import filialService from "../../../core/services/filial.service";

ChartJS.register(
  Title,
  Tooltip,
  Legend,
  CategoryScale,
  LinearScale
);

export default {

  data() {
    return {
      chartData: {
        labels: ["CT - Famrmacia", "C01", "C02"],
        datasets: [{ data: [0, 0, 0] }],
      },
      chartOptions: {
        responsive: true,
      },
      filtro: {
        filiais_id: null,
        data_inicio: null,
        data_fim: null,
      },
      isLoading: false,
      value: [],
      lista_produtos: [],
      nome_filial: "",
      porcentagens: [0, 0, 0, 0],
      total_atendimentos : 0
    };
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [{ title: "Relatorio" }]);
  },
  created() {
    this.filiais_id = filialService.getFilialId(),
      this.listar_filial();
  },
  computed: {
    num_atendimentos() {
      return this.$store.state.relatorios.num_atendimentos;
    },
    dados_transferencias() {
      return this.$store.state.relatorios.dados_transferencias;
    },
    num_ocorrencias_filial() {
      return this.$store.state.relatorios.num_ocorrencias_filial;
    },

    lista_filials() {
      return this.$store.state.configEmpresa.lista_filials;
    },
  },
  methods: {

    async listar_filial() {
      await this.$store.dispatch("configEmpresa/listar_filial");

    },

    async pesquisar() {
      console.log(this.filtro)
      this.isLoading = true
      await this.$store.dispatch(
        "relatorios/num_transferencias_por_filial",
        this.filtro
      );

      await this.$store.dispatch(
        "relatorios/num_atendimentos_por_filial",
        this.filtro
      );

      await this.$store.dispatch(
        "relatorios/get_num_ocorrencias",
        this.filtro
      );

      this.isLoading = false
      this.total_atendimentos = this.num_atendimentos[0].datasets;
      this.porcentagens[1] = ((100 * this.num_ocorrencias_filial[1]) / this.num_atendimentos[0].datasets).toFixed(2);
      this.porcentagens[2] = ((100 * this.num_ocorrencias_filial[2]) / this.num_atendimentos[0].datasets).toFixed(2);
      this.porcentagens[4] = ((100 * this.num_ocorrencias_filial[4]) / this.num_atendimentos[0].datasets).toFixed(2);

      console.log(this.porcentagens)
    },

    selectProduto(value, index) {
      this.lista_produtos = value
      this.nome_filial = index
    },



  },
};
</script>

<style></style>